module.exports = __webpack_public_path__ + "static/media/square-checkbox-checked.48ad466b.svg";